export default __webpack_public_path__ + "static/menu.dark-b0cb90ab2a9c362bc58ffa89cb0dc2aed4efe54951d54c6c76fe89f251f56941.png";